"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    item: Object
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  methods: {
    lookDetails: function lookDetails(e) {
      window.open(e);
    }
  }
};